import { render, staticRenderFns } from "./Downlink.vue?vue&type=template&id=527bec07&scoped=true&"
import script from "./Downlink.vue?vue&type=script&lang=js&"
export * from "./Downlink.vue?vue&type=script&lang=js&"
import style0 from "./Downlink.vue?vue&type=style&index=0&id=527bec07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527bec07",
  null
  
)

export default component.exports